import { Card, Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Rest from "../../../../libraries/Rest";
import Alert from "../../../../libraries/Alert";
import * as Components from "../../../../components/Components";
import Validator from "../../../../libraries/Validator";

function CompanyDepartmentForm() {
    const { companyId, id } = useParams();
    const navigate = useNavigate();
    const rest = new Rest();

    const isCreate = id?.toLowerCase() === 'add' ? true : false;

    /**
     * Init validator of payload
     */
    const validator = new Validator({
        code: { required: true },
        name: { required: true }
    });

    /**
     * Init states
     */
    const rootPath = `/companies/departments/${companyId}`;
    const endpoint = `/companies/departments/${companyId}`;

    let [payload, setPayload] = useState({
        parent_id: null,
        name: null,
        description: null,
    });
    let [departments, setDepartments] = useState([]);

    /**
     * First init function
     */
    const getDataById = async () => {
        const response = await rest.get(`${endpoint}/${id}`);
        if (response?.data?.data !== undefined) {
            const data = response.data.data;
            setPayload({
                parent_id: data?.parent_id,
                code: data?.code,
                name: data?.name,
                description: data?.description,
            });
        } else {
            Alert.showMessage('Error', 'error', 'Data is not found');
            navigate(rootPath);
        }
    }

    const getDepartments = async () => {
        const response = await rest.get(`${endpoint}?page=1&limit=100`);
        if (response?.data?.data?.data !== undefined) {
            const data = response?.data?.data?.data;

            /**
             * Translate data to option format
             */
            let options = [];
            for (let i = 0; i < data.length; i++) {
                options.push({
                    value: data[i]['id'] !== undefined ? data[i]['id'] : null,
                    label: data[i]['name'] !== undefined ? data[i]['name'] : null
                });
            }
            setDepartments(options);
        }
    }

    useEffect(() => {
        async function __init() {
            Alert.showLoading();
            await getDepartments();
            if (!isCreate) await getDataById();
            Alert.close();
        }
        __init();
    }, []);


    /**
     * Action handlers
     */
    const updatePayload = (field, value) => {
        setPayload({ ...payload, [field]: value });
    }

    const submit = async () => {
        /**
         * Validate input
         */
        const errMessages = validator.validate(payload);
        if (errMessages.length > 0) {
            let errMessageStrings = ``;
            for (let i = 0; i < errMessages.length; i++) {
                errMessageStrings += `${errMessages[i]}<br />`;
            }
            return Alert.showMessage(`Invalid input`, `warning`, errMessageStrings);
        }

        /**
         * Submit action
         */
        Alert.showConfirm({
            url: endpoint + (!isCreate ? `/${id}` : ``),
            method: isCreate ? 'POST' : 'PUT',
            data: payload,
        }).then((result) => {
            if (result.isConfirmed) {
                if (result?.value?.success) {
                    Alert.showMessage('Success', 'success', result?.value?.data?.message);
                    navigate(rootPath);
                } else {
                    Alert.showMessage('Failure', 'error', result?.value?.message);
                }
            }
        });
    }

    /**
     * Rendering DOM
     */
    return (
        <div>
            <div className="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <ol className="breadcrumb fs-sm mb-1">
                        <li className="breadcrumb-item">
                            <Link to="/dashboard">Dashboard</Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link to="/companies">List companies</Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link to={rootPath}>List departments</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Form {isCreate ? 'create' : 'edit'}
                        </li>
                    </ol>
                </div>
            </div>

            <Row className="g-3">
                <Col xl="12">
                    <Card className="card">
                        <Card.Header className="bg-primary">
                            <Card.Title
                                as="label"
                                className="fs-sm fw-medium mb-1 text-white"
                            >
                                Form {isCreate ? 'create' : 'edit'} department
                            </Card.Title>
                        </Card.Header>
                        <Card.Body className="bg-white">
                            <Link to={rootPath} className="btn btn-sm btn-warning text-white">
                                <i className="ri-arrow-left-line"></i> Back
                            </Link>
                            &nbsp;
                            <button className="btn btn-sm btn-primary" onClick={submit}>
                                <i className="ri-check-line"></i> Save
                            </button>
                            <br /><br />
                            <Row className="g-3">
                                <Col sm="6">
                                    <Components.Input
                                        type="text"
                                        name="code"
                                        label="Departname code"
                                        placeholder="Departname code"
                                        defaultValue={payload.code}
                                        change={updatePayload}
                                    />
                                </Col>
                                <Col sm="6">
                                    <Components.Input
                                        type="text"
                                        name="name"
                                        label="Departname name"
                                        placeholder="Departname name"
                                        defaultValue={payload.name}
                                        change={updatePayload}
                                    />
                                </Col>
                                <Col sm="6">
                                    <Components.Input
                                        type="text"
                                        name="description"
                                        label="Description"
                                        placeholder="Description"
                                        defaultValue={payload.description}
                                        change={updatePayload}
                                    />
                                </Col>
                                <Col sm="6">
                                    <Components.Select
                                        name="parent_id"
                                        label="Parent ID"
                                        defaultValue={payload.parent_id}
                                        options={departments}
                                        change={updatePayload}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default CompanyDepartmentForm;